import { Pipe, PipeTransform } from '@angular/core';
import { MarkdownContentService } from './markdown-content.service';

@Pipe({
  name: 'markdownExcerpt',
  standalone: true
})
export class MarkdownExcerptPipe implements PipeTransform {
  constructor(private readonly markdownContentService: MarkdownContentService) {}

  transform(value: string | null | undefined, maxLength = 160): string {
    return this.markdownContentService.toPlainText(value, maxLength);
  }
}